import { SearchableSelect } from "@risalabs_frontend_org/oasis-ui-kit";
import type { NarAgentGridInsuranceOption } from "../../narAgentGrid/hooks/useNarAgentGridInsuranceOptions";

const LINE_OF_BUSINESS_OPTIONS = [
  { value: "", label: "All LOBs" },
  { value: "medicare", label: "Medicare" },
  { value: "commercial", label: "Commercial" },
  { value: "medicaid", label: "Medicaid" },
];

interface HistoricNarConfigFiltersProps {
  payer: string;
  payerOptions: NarAgentGridInsuranceOption[];
  onPayerChange: (value: string) => void;
  lineOfBusiness: string;
  onLineOfBusinessChange: (value: string) => void;
}

/** Controlled payer and line-of-business filters for Historic NAR rows. */
const HistoricNarConfigFilters = ({
  payer,
  payerOptions,
  onPayerChange,
  lineOfBusiness,
  onLineOfBusinessChange,
}: HistoricNarConfigFiltersProps) => (
  <div className="mb-4 flex w-full flex-row items-end gap-3">
    <div className="min-w-0 flex-1">
      <SearchableSelect
        id="payer"
        label="Insurance (payer)"
        options={payerOptions}
        value={payer}
        onOptionChange={(option) => onPayerChange(option.value)}
        placeholder="All payers"
        searchPlaceholder="Search insurance"
      />
    </div>
    <div className="min-w-0 flex-1">
      <SearchableSelect
        id="line-of-business"
        label="Line of business"
        options={LINE_OF_BUSINESS_OPTIONS}
        value={lineOfBusiness}
        onOptionChange={(option) => onLineOfBusinessChange(option.value)}
        placeholder="All LOBs"
        searchPlaceholder="Search line of business"
      />
    </div>
  </div>
);

export default HistoricNarConfigFilters;
